//Include Both Helper File with needed methods
import { jwtDecode } from "jwt-decode";
import axios from "axios";

import {
  apiError,
  paymentStatus,
  userPackage,
  userCards,
  userTransactions
} from "./reducer";

import apiUrl, { localPath } from "slices/apiEndpoint";
import { setPaymentProvider } from "slices/userProfile/reducer";
import { store } from "index";
import api from "Common/api";
import { getAuthPayload, isContractorUser } from "Common/permissions";

export const getPaymentStatus = () => async (dispatch: any) => {
  if (!isContractorUser(getAuthPayload().userType)) {
    return null;
  }

  try {
    const response = await api.get(
      `/payment/get-payment-status/${getDecodeId()}`
    );
    let data = response.data;
    //console.log(data.isVerified, "ddd")
    if (data) {
      console.log(data, "datadatabbbbb")
      dispatch(paymentStatus(data.isVerified));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const createSubscription =
  (userEmail: any, userPackage: any) => async (dispatch: any) => {
    try {
      const response = await api.post(
        `/stripe-sub/create-stripe-session-subscription`,
        {
          email: userEmail,
          package: userPackage,
        }
      );
      let data = response.data;
      //console.log(data, "ddd")
      if (data) {
        dispatch(userPackage(data));
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };

export const getSubscribedCustomer =
  (userEmail: any) => async (dispatch: any) => {
    try {
      const response = await api.post(
        `/stripe-sub/get-subscribed-customer`,
        {
          email: userEmail,
        }
      );
      let data = response.data;
      //console.log(data, "ksnkdk")
      if (data) {
        dispatch(userPackage(data));
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };

export const checkPaymentStatus = () => async (dispatch: any) => {
  if (!isContractorUser(getAuthPayload().userType)) {
    return null;
  }

  try {
    const response = await api.get(
      `/payment/check-user-payment-verified/${getDecodeId()}`
    );
    let data = response;
    if (data) {
      return data;
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const getCards = (userId: any) => async (dispatch: any) => {
  try {
    const response = await api.get(
      `/stripe/api/get-saved-cards/${userId}`
    );
    let data = response;
    if (data) {
      dispatch(userCards(data.data));
      return data.data;
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const getTransactions = (userId: any) => async (dispatch: any) => {
  try {
    const token = store.getState().Login.token
    const response = await api.post(
      // `${localPath}/api/subscription/get-subscription-details`,
      `/stripe-sub/get-subscription-details`,
      {
        userId: userId,

      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization:`Bearer ${token}` ,
        }
      }
    );
    let data = response.data;
    console.warn(data, "details")
    if (data) {
     dispatch(setPaymentProvider(data.paymentProvider))
      
      dispatch(userTransactions(data));
    }
  } catch (error:any) {
    console.warn(error)
    dispatch(setPaymentProvider(error.paymentProvider||error?.response?.data?.paymentProvider))


    dispatch(apiError(error));
  }
};

function getDecodeId() {
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode(token);
  } else {
    console.error("Token is null");
  }
  return decoded.userId;
}
